import React from 'react';
import {
  Box,
  Button,
  HStack,
  Stack,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import { useTranslation } from 'i18n/TranslationProvider';

function formatDateTime(value) {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleString();
}

export default function ListingLoaCard({
  listingId,
  loa,
  title = 'Letter of Attorney',
  description = 'The transport authorization is generated once the assigned fleet and dates are confirmed.',
}) {
  const borderColor = useColorModeValue('gray.100', 'whiteAlpha.200');
  const mutedColor = useColorModeValue('gray.500', 'gray.400');
  const titleColor = useColorModeValue('navy.800', 'white');
  const {t} = useTranslation();
  const apiBase = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
  const downloadHref = loa?.downloadUrl || (listingId && loa ? `${apiBase}/listings/${listingId}/loa/download` : '');

  return (
    <Box border="1px solid" borderColor={borderColor} borderRadius="22px" p={5}>
      <Stack spacing={3}>
        <Box>
          <Text fontSize="md" fontWeight="800" color={titleColor}>
            {t(title)}
          </Text>
          <Text fontSize="sm" color={mutedColor} mt={1}>
            {t(description)}
          </Text>
        </Box>

        {loa ? (
          <>
            <HStack justify="space-between" flexWrap="wrap">
              <Text fontSize="sm" color={mutedColor}>Document</Text>
              <Text fontSize="sm" fontWeight="700" color={titleColor}>{loa.number || '—'}</Text>
            </HStack>
            <HStack justify="space-between" flexWrap="wrap">
              <Text fontSize="sm" color={mutedColor}>Revision</Text>
              <Text fontSize="sm" fontWeight="700" color={titleColor}>#{loa.revision || 1}</Text>
            </HStack>
            <HStack justify="space-between" flexWrap="wrap">
              <Text fontSize="sm" color={mutedColor}>Generated</Text>
              <Text fontSize="sm" fontWeight="700" color={titleColor}>{formatDateTime(loa.generatedAt)}</Text>
            </HStack>
            <HStack justify="space-between" flexWrap="wrap">
              <Text fontSize="sm" color={mutedColor}>Verification code</Text>
              <Text fontSize="sm" fontWeight="700" color={titleColor}>{loa.verificationCode || '—'}</Text>
            </HStack>
            <Button
              as="a"
              href={downloadHref}
              target="_blank"
              rel="noopener noreferrer"
              colorScheme="blue"
              variant="outline"
              borderRadius="16px"
            >
              Open LOA PDF
            </Button>
          </>
        ) : (
          <Text fontSize="sm" color={mutedColor}>
            {t('No letter of attorney has been generated yet.')}
          </Text>
        )}
      </Stack>
    </Box>
  );
}
